import { useEffect, useMemo, useState } from 'react'
import {
  buildPricingMap,
  fetchAiToolPricing,
  formatLowestAiToolPrice,
  getCachedAiToolPricing,
  getPricingAmount,
  getPricingLabel,
} from '../utils/aiTool/pricing'

function getInitialPricingState() {
  const cached = getCachedAiToolPricing()
  return {
    pricingList: cached,
    loaded: cached.length > 0,
    loading: cached.length === 0,
  }
}

export function useAiToolPricing() {
  const initial = getInitialPricingState()
  const [pricingList, setPricingList] = useState(initial.pricingList)
  const [loading, setLoading] = useState(initial.loading)
  const [loaded, setLoaded] = useState(initial.loaded)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (loaded) {
      return undefined
    }

    let active = true

    fetchAiToolPricing()
      .then((data) => {
        if (!active) {
          return
        }

        setPricingList(data)
        setLoaded(Array.isArray(data) && data.length > 0)
      })
      .catch((err) => {
        if (active) {
          setError(err)
          setLoaded(false)
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false)
        }
      })

    return () => {
      active = false
    }
  }, [loaded])

  const pricingMap = useMemo(
    () => buildPricingMap(pricingList),
    [pricingList],
  )

  return {
    pricingList,
    pricingMap,
    loading,
    loaded,
    error,
    getPricingLabel: (options) =>
      loaded ? getPricingLabel(pricingMap, options) : '',
    getPricingAmount: (options) =>
      loaded ? getPricingAmount(pricingMap, options) : '',
    formatLowestPrice: (options) =>
      loaded ? formatLowestAiToolPrice(pricingList, options) : '',
  }
}
